// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 5: A IGREJA PRIMITIVA
// ============================================================================
// Níveis 53-65 (13 níveis, 39 perguntas)

export const chapter5Translations = {
  name: "A Igreja Primitiva",
  description: "Recebereis poder...",
  
  spiritualWisdom: {
    principle: "O Espírito Santo dá poder e coragem para testemunhar",
    scripture: "Recebereis poder ao descer sobre vós o Espírito Santo, e ser-me-eis testemunhas (Atos 1:8)",
    application: "A Igreja nasce no fogo do Espírito e cresce pelo testemunho corajoso"
  },
  
  levels: {
    53: {
      name: "A Ascensão",
      challenge: "Ser-me-eis testemunhas... até aos confins da terra...",
      easy: {
        question: "Quantos dias após a ressurreição Jesus subiu ao céu?",
        options: ["30 dias", "40 dias", "50 dias", "60 dias"],
        hint: "Número bíblico de preparação",
        funFact: "☁️ 40 dias de ensino intensivo antes da missão mundial!"
      },
      medium: {
        question: "Que promessa Jesus fez antes de subir ao céu?",
        options: [
          "Que voltaria imediatamente",
          "Que enviaria o Espírito Santo com poder",
          "Que construiria a igreja",
          "Que puniria os maus"
        ],
        hint: "Poder do alto",
        funFact: "⚡ Promessa do Espírito Santo - transformação dos discípulos assustados!"
      },
      hard: {
        question: "O que a Ascensão simboliza na nossa vida espiritual?",
        options: [
          "O fim da presença de Jesus",
          "Jesus reina no céu e intercede por nós",
          "Uma despedida final",
          "Um mito simbólico"
        ],
        hint: "Trata-se de uma presença viva na glória",
        funFact: "👑 Jesus está sentado à direita de Deus, reina e intercede por nós!"
      }
    },
    
    54: {
      name: "Pentecostes",
      challenge: "Todos foram cheios do Espírito Santo e começaram a falar...",
      easy: {
        question: "Quantos dias após a Ascensão ocorreu Pentecostes?",
        options: ["7 dias", "10 dias", "14 dias", "20 dias"],
        hint: "Cerca de dez dias",
        funFact: "🔟 10 dias de oração fervorosa preparam o derramamento do Espírito!"
      },
      medium: {
        question: "De que forma o Espírito Santo se manifestou?",
        options: [
          "Como um vento impetuoso",
          "Como línguas de fogo repartidas",
          "Como uma pomba",
          "Como luz"
        ],
        hint: "Chamas pousando sobre cada discípulo",
        funFact: "🔥 Línguas de fogo: o Espírito dá coragem e o dom de línguas!"
      },
      hard: {
        question: "O que Pentecostes representa para a Igreja universal?",
        options: [
          "Um evento histórico isolado",
          "O nascimento oficial da Igreja missionária",
          "Um milagre de curiosidade",
          "O início de uma festa"
        ],
        hint: "Trata-se da certidão de nascimento da Igreja",
        funFact: "🎂 Pentecostes = aniversário da Igreja, início da missão mundial!"
      }
    },

    55: {
      name: "O Primeiro Sermão de Pedro",
      challenge: "Que faremos, irmãos? Arrependei-vos...",
      easy: {
        question: "Quantas pessoas foram batizadas após o sermão de Pedro?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Três mil almas",
        funFact: "🌊 3000 batismos num dia - despertar espiritual extraordinário!"
      },
      medium: {
        question: "Do que Pedro acusou a multidão?",
        options: [
          "Ignorância",
          "Ter crucificado Jesus, o Messias",
          "Falta de fé",
          "Hipocrisia"
        ],
        hint: "O pecado supremo contra o Filho de Deus",
        funFact: "⚔️ Pedro, que negou Jesus, agora proclama Sua divindade!"
      },
      hard: {
        question: "Como a transformação de Pedro mostra a obra do Espírito Santo?",
        options: [
          "Tornou-se mais educado",
          "De medroso e instável a corajoso e firme na fé",
          "Ganhou poder",
          "Mudou de personalidade"
        ],
        hint: "Trata-se de santificação pelo Espírito",
        funFact: "🗿 'Cana agitada' torna-se 'rocha sólida' - poder de transformação!"
      }
    },

    56: {
      name: "A Primeira Comunidade",
      challenge: "Perseveravam na doutrina dos apóstolos e na comunhão...",
      easy: {
        question: "Como os primeiros cristãos partilhavam os bens?",
        options: [
          "Cada um guardava o seu",
          "Partilhavam tudo",
          "Só os ricos davam",
          "Por obrigação legal"
        ],
        hint: "Partilha voluntária dos bens",
        funFact: "🤝 Amor fraternal tão intenso que partilhavam tudo voluntariamente!"
      },
      medium: {
        question: "Em que os primeiros cristãos gastavam o seu tempo?",
        options: [
          "Só nos negócios",
          "Ensino, comunhão, partir do pão, oração",
          "Só no trabalho",
          "Lazer"
        ],
        hint: "Os quatro pilares da vida comunitária",
        funFact: "⛪ Ensino, comunhão, Eucaristia, oração - fundamentos da Igreja!"
      },
      hard: {
        question: "Por que essa primeira comunidade era tão atraente?",
        options: [
          "Eram ricos",
          "Amor genuíno e alegria irradiavam da sua unidade",
          "Prometiam milagres",
          "Criticavam os outros"
        ],
        hint: "Trata-se de testemunho vivo do amor",
        funFact: "✨ 'Vede como eles se amam!' - testemunho mais convincente que palavras!"
      }
    },

    57: {
      name: "A Cura do Coxo",
      challenge: "Não tenho prata nem ouro, mas o que tenho, isso te dou...",
      easy: {
        question: "Há quanto tempo esse homem era coxo?",
        options: [
          "20 anos",
          "30 anos", 
          "Desde o nascimento",
          "10 anos"
        ],
        hint: "Deficiência desde o nascimento",
        funFact: "🚶 40 anos de deficiência curados instantaneamente em nome de Jesus!"
      },
      medium: {
        question: "Em nome de quem Pedro curou o coxo?",
        options: [
          "Em nome de Deus",
          "Em nome de Jesus Cristo de Nazaré",
          "Em seu próprio nome",
          "Em nome de Abraão"
        ],
        hint: "O Nome acima de todo nome",
        funFact: "✊ O Nome de Jesus continua a fazer milagres através dos apóstolos!"
      },
      hard: {
        question: "O que essa cura simboliza para o Evangelho?",
        options: [
          "Um simples milagre médico",
          "A salvação completa que Jesus traz: espiritual e física",
          "O poder dos apóstolos",
          "Caridade para os pobres"
        ],
        hint: "Trata-se da salvação total do homem",
        funFact: "🩺 Jesus cura alma e corpo - salvação completa do homem!"
      }
    },

    58: {
      name: "Início da Perseguição",
      challenge: "Importa obedecer antes a Deus do que aos homens...",
      easy: {
        question: "Quem prendeu Pedro e João após a cura do coxo?",
        options: [
          "Os romanos",
          "Os saduceus e sacerdotes",
          "O povo",
          "Pilatos"
        ],
        hint: "Autoridades religiosas judaicas",
        funFact: "⛓️ Primeira perseguição religiosa - o Evangelho perturba o establishment!"
      },
      medium: {
        question: "O que as autoridades proibiram os apóstolos de fazer?",
        options: [
          "Deixar Jerusalém",
          "Ensinar mais em nome de Jesus",
          "Fazer mais milagres",
          "Orar mais"
        ],
        hint: "Proibição de pregar",
        funFact: "🚫 Tentativa de silenciar a verdade - impossível parar o Evangelho!"
      },
      hard: {
        question: "Como os apóstolos reagiram à proibição?",
        options: [
          "Tiveram medo e obedeceram",
          "Afirmaram que devem obedecer a Deus antes que aos homens",
          "Negociaram",
          "Fugiram"
        ],
        hint: "Trata-se de lealdade superior à lei humana",
        funFact: "⚖️ Desobediência civil para obedecer a Deus - coragem das convicções!"
      }
    },

    59: {
      name: "Ananias e Safira",
      challenge: "Não mentiste aos homens, mas a Deus...",
      easy: {
        question: "Que mentira Ananias e Safira disseram?",
        options: [
          "Não tinham vendido nada",
          "Guardaram uma parte dizendo que davam tudo",
          "Eram pobres",
          "Não eram casados"
        ],
        hint: "Mentira sobre o valor doado",
        funFact: "💰 Guardar uma parte era permitido, mentir sobre a oferta não!"
      },
      medium: {
        question: "O que aconteceu com eles após a mentira?",
        options: [
          "Foram perdoados",
          "Morreram instantaneamente",
          "Foram expulsos",
          "Arrependeram-se"
        ],
        hint: "Castigo severo imediato",
        funFact: "⚱️ Juízo severo para preservar a pureza da Igreja recém-nascida!"
      },
      hard: {
        question: "Por que castigo tão severo no início da Igreja?",
        options: [
          "Deus era cruel",
          "Para estabelecer a santidade exigida da comunidade",
          "Para assustar",
          "Acaso"
        ],
        hint: "Trata-se de preservar a integridade espiritual",
        funFact: "🔥 Padrões elevados no início para estabelecer cultura de santidade!"
      }
    },

    60: {
      name: "Os Sete Diáconos",
      challenge: "Escolhei dentre vós sete homens de boa reputação...",
      easy: {
        question: "Quantos diáconos foram escolhidos?",
        options: ["5", "6", "7", "12"],
        hint: "Número da perfeição",
        funFact: "7️⃣ Sete diáconos para servir - organização divina da Igreja!"
      },
      medium: {
        question: "Qual era o seu papel principal?",
        options: [
          "Pregar o Evangelho",
          "Servir às mesas e ajudar as viúvas",
          "Batizar novos convertidos",
          "Gerir as finanças"
        ],
        hint: "Serviço social e material",
        funFact: "🍽️ Serviço às mesas = primeira organização caritativa cristã!"
      },
      hard: {
        question: "O que essa organização revela sobre a visão cristã do serviço?",
        options: [
          "O trabalho material é inferior",
          "Serviço espiritual e material são igualmente sagrados",
          "Deve-se separar o sagrado do secular",
          "Só os sacerdotes servem verdadeiramente"
        ],
        hint: "Trata-se da sacralidade de todo serviço de amor",
        funFact: "✨ Servir às mesas com a mesma dignidade que pregar - todo serviço é sagrado!"
      }
    },

    61: {
      name: "Estêvão, Primeiro Mártir",
      challenge: "Senhor, não lhes imputes este pecado! Dito isto, adormeceu...",
      easy: {
        question: "Qual era o papel de Estêvão na Igreja?",
        options: ["Apóstolo", "Diácono", "Sacerdote", "Profeta"],
        hint: "Um dos sete escolhidos para servir",
        funFact: "✨ Estêvão: diácono torna-se poderoso evangelizador e primeiro mártir!"
      },
      medium: {
        question: "Do que Estêvão acusou os líderes judeus?",
        options: [
          "Corrupção",
          "Resistir sempre ao Espírito Santo",
          "Hipocrisia",
          "Ganância"
        ],
        hint: "Resistência histórica a Deus",
        funFact: "📜 Estêvão resume a história: rebelião constante contra Deus!"
      },
      hard: {
        question: "Como Estêvão morreu e o que sua atitude revela?",
        options: [
          "Com raiva dos executores",
          "Perdoando como Jesus na cruz",
          "Em desespero",
          "Amaldiçoando os inimigos"
        ],
        hint: "Trata-se de imitação perfeita de Cristo",
        funFact: "💝 Perdão aos executores: Estêvão reproduz perfeitamente a atitude de Jesus!"
      }
    },

    62: {
      name: "Filipe e o Eunuco Etíope",
      challenge: "Como poderei entender se alguém não me explicar?",
      easy: {
        question: "O que o eunuco estava lendo na carruagem?",
        options: [
          "Salmos",
          "O profeta Isaías",
          "Gênesis",
          "Provérbios"
        ],
        hint: "Profeta da paixão do Messias",
        funFact: "📖 Isaías 53 - profecia perfeita sobre Jesus lida por um buscador sincero!"
      },
      medium: {
        question: "Como Filipe explicou a passagem de Isaías?",
        options: [
          "Falou de história antiga",
          "Anunciou Jesus a partir desse texto",
          "Deu uma aula de teologia",
          "Criticou a interpretação"
        ],
        hint: "A Escritura conduz naturalmente a Cristo",
        funFact: "✝️ Toda a Escritura converge para Jesus - chave de compreensão!"
      },
      hard: {
        question: "O que a conversão do eunuco etíope simboliza?",
        options: [
          "Conversão isolada",
          "Universalidade do Evangelho para todas as raças e condições",
          "Superioridade de uma etnia",
          "Caso especial"
        ],
        hint: "Trata-se de abertura às nações",
        funFact: "🌍 Etíope, eunuco, ministro: o Evangelho quebra todas as barreiras!"
      }
    },

    63: {
      name: "Conversão de Saulo de Tarso",
      challenge: "Saulo, Saulo, por que me persegues?",
      easy: {
        question: "O que Saulo fazia antes da conversão?",
        options: [
          "Pregava o Evangelho",
          "Perseguia os cristãos",
          "Era neutro",
          "Só estudava"
        ],
        hint: "Inimigo feroz dos discípulos",
        funFact: "⚔️ Saulo respirava ameaças e morte contra os discípulos de Jesus!"
      },
      medium: {
        question: "Em qual estrada Jesus apareceu a Saulo?",
        options: [
          "Estrada para Jerusalém",
          "Estrada para Damasco",
          "Estrada para Gaza",
          "Estrada para Antioquia"
        ],
        hint: "Cidade na Síria",
        funFact: "🛤️ Estrada de Damasco = lugar de transformação mais famoso da história!"
      },
      hard: {
        question: "Como essa conversão demonstra a graça de Deus?",
        options: [
          "Deus só converte pessoas boas",
          "A graça pode transformar o pior inimigo no maior apóstolo",
          "A conversão foi merecida",
          "Saulo já estava perto de Deus"
        ],
        hint: "Trata-se do poder transformador da graça",
        funFact: "⚡ Do maior perseguidor ao maior missionário - milagre da graça!"
      }
    },

    64: {
      name: "Pedro e Cornélio",
      challenge: "Reconheço verdadeiramente que Deus não faz acepção de pessoas...",
      easy: {
        question: "Qual era a profissão de Cornélio?",
        options: [
          "Comerciante",
          "Centurião romano",
          "Sacerdote",
          "Escriba"
        ],
        hint: "Oficial do exército romano",
        funFact: "🎖️ Primeiro gentio oficialmente convertido - abertura aos não-judeus!"
      },
      medium: {
        question: "Que visão Pedro teve antes de encontrar Cornélio?",
        options: [
          "Anjo falando",
          "Lençol com animais puros e impuros",
          "Jesus aparecendo",
          "Templo destruído"
        ],
        hint: "Visão sobre pureza e impureza",
        funFact: "🕊️ Lençol com animais: Deus abole distinções de alimentos e raças!"
      },
      hard: {
        question: "Que princípio revolucionário essa conversão estabeleceu?",
        options: [
          "Romanos são superiores",
          "Deus não faz acepção de pessoas - salvação universal",
          "Deve-se abandonar tradições",
          "Circuncisão é inútil"
        ],
        hint: "Trata-se da universalidade da salvação",
        funFact: "🌍 Revolução espiritual: o Evangelho é para todos os povos sem exceção!"
      }
    },

    65: {
      name: "A Igreja de Antioquia",
      challenge: "Em Antioquia os discípulos foram pela primeira vez chamados cristãos...",
      easy: {
        question: "Como os discípulos foram chamados pela primeira vez em Antioquia?",
        options: ["Discípulos", "Cristãos", "Crentes", "Santos"],
        hint: "O nome que temos até hoje",
        funFact: "✝️ 'Cristãos' = 'pequenos Cristos' - nome de honra dado pelos pagãos!"
      },
      medium: {
        question: "Quem veio ensinar em Antioquia junto com Barnabé?",
        options: [
          "Pedro",
          "Paulo (Saulo)",
          "Tiago",
          "João"
        ],
        hint: "Ex-perseguidor tornado apóstolo",
        funFact: "👥 Barnabé procura Paulo em Tarso - início do ministério de Paulo!"
      },
      hard: {
        question: "Por que Antioquia se tornou tão importante na história cristã?",
        options: [
          "Era rica",
          "Primeiro centro missionário para os gentios",
          "Estava bem localizada",
          "Tinha bons líderes"
        ],
        hint: "Trata-se de expansão missionária",
        funFact: "🚢 Antioquia: porto de partida de todas as viagens missionárias de Paulo à Europa!"
      }
    }
  }
};

export default chapter5Translations;
